import * as request from '@/utils/request'

const BASE = '/paas/training'

export default {
  // 培训列表
  getTrainingList(data) {
    return request.post(`${BASE}/list`, data)
  },
  // 保存（新增/编辑）
  saveTraining(data) {
    return request.post(`${BASE}/save`, data)
  },
  // 详情
  getTrainingInfo(id) {
    return request.post(`${BASE}/view/${id}`)
  },
  // 删除
  deleteTraining(id) {
    return request.post(`${BASE}/delete/${id}`)
  },
  // 报名记录
  getEnrollmentList(data) {
    return request.get('/paas/training_apply_record/list', data)
  }
}
